// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/button/style/index.less
// module id = 1028
// module chunks = 1